export enum USTAMatchFormatTypeEnum {
  STANDARD = 'STANDARD',
  SHORT = 'SHORT',
  PRO = 'PRO',
  TIEBREAK = 'TIEBREAK',
  TIMED = 'TIMED',
}
export interface MatchUpFormatInterface {
  key: string;
  description: string;
  matchUpFormat: string;
  type: USTAMatchFormatTypeEnum;
}
export interface MappedDialogFormatsReturnObject {
  standard: MatchUpFormatInterface[];
  short: MatchUpFormatInterface[];
  pro: MatchUpFormatInterface[];
  tiebreak: MatchUpFormatInterface[];
  timed: MatchUpFormatInterface[];
}

export interface CheckedScoreFormat {
  format: string;
  drawStructureIds: {
    structureId: string;
    drawId: string;
  }[];
}

export interface MatchUpFormatMap {
  [key: string]: MatchUpFormatInterface;
}
